@if (dateRequired) {
  <div class="grid-x grid-margin-x">
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="fromDateChanged($event)" [initialDate]="fromDate"></common-date-picker>
    </div>
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'toDate'" (dateUpdated)="toDateChanged($event)" [initialDate]="toDate"></common-date-picker>
    </div>
    <div class="cell small-6 medium-6 large-2 text-align-center">
      <button (click)="generateReport()" [disabled]="invalidDateCombination" class="button">
        {{runText}}
      </button>
    </div>
    <div class="cell small-6 medium-6 large-2 text-right">
      <button (click)="downloadReport()" class="button" [disabled]="invalidDateCombination">
        Download Report
      </button>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-8">
      &nbsp;
    </div>
    <div class="cell small-12 medium-6 large-4">
      @if (invalidDateCombination) {
        <span class="small-font-size red italic">From Date must be less than To Date</span>
      }
    </div>
  </div>
} @else {
  <div class="grid-x grid-margin-x">
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell small-11 medium-2 large-2 date-picker-cell">
      <common-date-picker [id]="'fromDate'" [disabled]="noDateSelected" (dateUpdated)="fromDateChanged($event)" [initialDate]="fromDate"></common-date-picker>
    </div>
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell small-11 medium-2 large-2 date-picker-cell">
      <common-date-picker [id]="'toDate'" [disabled]="noDateSelected" (dateUpdated)="toDateChanged($event)" [initialDate]="toDate"></common-date-picker>
    </div>
    <div class="cell small-12 medium-2 large-2">
      <div class="checkbox">
        <label>
          <input class="show-for-sr" type="checkbox" id="noDate" [(ngModel)]="noDateSelected" />
          <label aria-hidden="true" for="noDate">
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
            <span class="control-label-text padding-left">{{noDateLabel}}</span>
          </label>
        </label>
      </div>
    </div>
    <div class="cell small-6 medium-2 large-2 text-align-center">
      <button (click)="generateReport()" [disabled]="invalidDateCombination" class="button">
        {{runText}}
      </button>
    </div>
    <div class="cell small-6 medium-2 large-2 text-right">
      <button (click)="downloadReport()" class="button" [disabled]="invalidDateCombination">
        Download Report
      </button>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-4">
      @if (invalidDateCombination) {
        <span class="small-font-size red italic">From Date must be less than To Date</span>
      }
    </div>
  </div>
}



